<template>
  <v-container v-if="ready" class="pa-0">
    <template v-if="currentTab === 0">
      <h1>常見問題</h1>
      <div v-for="(faq, idx) in faqs" :key="idx">
        <h2>{{faq.category}}</h2>
        <div class="expand-panel">
          <div
            v-for="(coreFaq, i) in faq.faqs"
            :key="i"
            class="accordion-panel"
          >
            <div class="panel-inset">
              <div
                class="accordion-btn"
                @click="showPanelItem(i, idx);"
                :style="panelItemTitle(i)"
              >
                <span v-html="coreFaq.question"></span>
                <img
                  class="accordion-btn-chevron"
                  :class="{ upsideDown: panelItem == i && panel == idx }"
                  src="../../assets/img/arrow-down.svg"
                />
              </div>
              <div
                :style="{ display: panelItemVisible(i, idx) }"
                class="accordion-panel"
              >
                <p v-html="coreFaq.answer"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inline">
        <h2>聯絡客服（康太數位)</h2>
        <div 
          class="record-btn" 
          @click="goRecord()"
        >
          客服紀錄
        </div>
      </div>
      <div class="contact-area">
        <div v-if="termsFromApi" v-html="termsFromApi" class="mb-4"></div>
        <div v-else>
          <p>康太數位服務專線：(02) 7729-9040</p>
          <p>週一至週五  09:00 ~ 18:00</p>
        </div>
        <div 
          class="contact-btn"
          @click="contactService()"
        >
          <img src="@/assets/img/icon/contact_us.svg">
          聯絡我們
        </div>
      </div>
    </template>
    <template v-else>
      <h1>客服紀錄</h1>
      <div
        v-for="(record, index) in filtedRecords"
        :key="index"
        class="question-block"
        :style="recordBgColor(index)"
        @click="seeRecord(index)"
      >
        <div class="question-info">
          <div class="question-title question-block-inline">
            {{ record.title }}
          </div>
          <div class="question-btm">
            <div
              v-show="record.orderNo"
              class="question-ordercode question-block-inline"
            >
              訂單編號：{{ record.orderNo }}
            </div>
            <div class="question-time">
              {{ record.modifyTime | formatDateTime('YYYY/MM/DD') }}
            </div>
          </div>
        </div>
        <div class="question-arrow">
          <img src="@/assets/img/icon/record_arrow.svg" />
        </div>
      </div>
    </template>
  </v-container>
  <Spinner v-else bgc="#f6f6f6" />
</template>

<script>
import CarouselBar from '@/components/CarouselBar.vue'
import Spinner from '@/components/shared/Spinner.vue'

export default {
  name: 'CustomerService',
  components: {
    CarouselBar,
    Spinner,
  },
  data: function() {
    return {
      types: ['常見問題', '客服聯絡記錄'],
      currentTab: 0,
      panel: null,
      panelItem: null,
      faqs: [],
      records: [],
      filterIndex: 10,
      ready: false,
      counter: 0,
      termsFromApi: '',
    }
  },
  computed: {
    filtedRecords() {
      return this.records.slice(0, this.filterIndex)
    },
    inTheEnd() {
      return this.filterIndex >= this.records.length
    },
  },
  mounted() {
    if (this.$route.params.type !== undefined && this.$route.params.type == 1) {
      this.currentTab = 1
      // 37 取得案件列表
      api.getCustomerServiceList().then(res => {
        return (this.records = res.data), (this.ready = true)
      })
    } else {
      // 35 常見問題(問答)
      this.currentTab = 0
      api.getFaq().then(res => {
        console.log(this.arrangeFaqs(res.data))
        return (this.faqs = this.arrangeFaqs(res.data)), (this.ready = true)
      })
    }
  },
  updated() {
    if (this.panel !== undefined && this.panel !== null) {
      const anchor = document.getElementsByClassName('expand-panel')[this.panel]
      if (this.panelItem !== undefined && this.panelItem !== null) {
        anchor
          .querySelectorAll('.panel-inset:not(.accordion-btn)')
          [this.panelItem].scrollIntoView(true)
      } else {
        anchor.scrollIntoView(true)
      }
    }
  },
  methods: {
    handleScroll() {
      if (!this.currentTab || this.inTheEnd) {
        return
      }
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const scrollHeight =
        document.documentElement.scrollHeight ||
        document.body.scrollTscrollHeightop
      const windowHeight = window.screen.height
      const scrollBottom = scrollTop + windowHeight
      if (scrollBottom >= scrollHeight - 20) {
        this.filterIndex += 10
      }
    },
    contactService() {
      this.$router.push({
        name: 'contactCustomerServicePage',
        params: { questionType: this.currentTab, orderNo: '0' },
      })
    },
    seeRecord(i) {
      this.$router.push({
        name: 'serviceAskingPage',
        params: { type: 1, serviceNo: this.records[i].serviceNo },
      })
    },
    // showPanel(index) {
    //   this.panel = this.panel === index ? null : index
    //   console.log(this.panel)
    //   this.panelItem = null
    // },
    panelVisible(index) {
      return this.panel === index ? 'block' : 'none'
    },
    panelTitle(index) {
      return this.panel === index
        ? { color: '#222222', fontWeight: '500' }
        : { color: '#4a4a4a', fontWeight: 'normal' }
    },
    showPanelItem(contentIdx, titleIdx) {
      this.panel = this.titleIdx === titleIdx ? null : titleIdx
      this.panelItem = this.panelItem === contentIdx ? null : contentIdx
    },
    panelItemVisible(contentIdx, titleIdx ) {
      return this.panelItem === contentIdx && this.panel === titleIdx ? 'block' : 'none'
    },
    panelItemTitle(index) {
      return this.panelItem === index
        ? { fontWeight: '500' }
        : { fontWeight: 'normal' }
    },
    selectTab(index) {
      if (this.currentTab != index) {
        this.$router.replace({
          name: 'customerServicePage',
          params: { type: index },
        })
      }
    },
    recordBgColor(index) {
      if (!this.records[index].newMessage) {
        return { backgroundColor: '#fff' }
      } else {
        return { backgroundColor: 'rgba(29, 167, 252, 0.1)' }
      }
    },
    convertZhNum(num) {
      // 只處理 0 ~ 99
      const zhDigit = [
        '零',
        '一',
        '二',
        '三',
        '四',
        '五',
        '六',
        '七',
        '八',
        '九',
        '十',
      ]
      const length = String(num).length
      if (length == 1) {
        return zhDigit[num]
      } else if (length == 2) {
        if (num == 10) {
          return zhDigit[num]
        } else if (num > 10 && num < 20) {
          return '十' + zhDigit[String(num).charAt(1)]
        } else {
          return (
            zhDigit[String(num).charAt(0)] +
            '十' +
            zhDigit[String(num).charAt(1)].replace('零', '')
          )
        }
      }
    },
    arrangeFaqs(originFaqs) {
      const groupFaqs = originFaqs.reduce((acc, cur, currentIndex) => {
        if (cur.question) {
          const arrOrder = cur.categorySeq
          const faq = {
            questionSeq: cur.questionSeq,
            questionId: cur.questionId,
            question: cur.question,
            answer: cur.answer,
          }
          if (!acc[arrOrder]) {
            acc[arrOrder] = {
              mark: cur.mark,
              id: cur.id,
              category: cur.category,
              faqs: [faq],
            }
          } else {
            acc[arrOrder].faqs.push(faq)
          }
        }
        return acc
      }, [])
      const arr = []
      for (const i of groupFaqs) {
        i && arr.push(i)
      }
      return arr
    },
    goRecord() {
      this.$router.replace({
        name: 'customerServicePage',
        params: { type: 1 },
      })
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
    this.termsFromApi = JSON.parse(
      window.localStorage.getItem('initial_config')
    ).terms.customerService.question
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss" scoped>
.container {
  background-color: #f3f5f8;
}

::v-deep p {
  margin-bottom: 8px;
}

::v-deep .v-expansion-panels {
  border-radius: 0px;
  font-size: 16px;
  color: #222222;
}

::v-deep .carousel-item {
  flex: 1;
  backdrop-filter: blur(20px);
  box-shadow: 0 -0.5px 0 0 rgba(0, 0, 0, 0.3);
  background-color: rgba(247, 247, 247, 0.8);
}

img {
  object-fit: contain;
}

.contact-block {
  background-color: #ffffff;
}

.contact-block > ::v-deep .v-btn {
  font-size: 16px;
  font-weight: normal;
}

.contact-block-text {
  font-size: 16px;
  line-height: 24px;
  color: #545454;
}

.contact-block-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.expand-panel {
  background-color: #ffffff;
  padding: 10px 0;
}

.expand-panel > div.accordion-btn {
  padding: 6px 0px;
  font-size: 16px;
  color: #222222;
}

.accordion-panel > .panel-inset > div.accordion-btn {
  font-size: 16px;
  color: #2a2b2b;
  padding: 10px 16px;
}

.accordion-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.accordion-btn > span {
  flex: 1 1 auto;
}

.accordion-btn-arrow {
  width: 11px;
  height: 9px;
}

.accordion-btn-chevron {
  width: 16px;
  height: 16px;
  margin-right: 1.9%;
  &.upsideDown {
    transform: rotate(180deg);
  }
}

.accordion-panel {
  overflow: hidden;
}

.accordion-panel > .panel-inset > div.accordion-panel {
  padding: 16px 16px 16px 16px;
  font-size: 14px;
  line-height: 1.5;
  color: #777;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.question-block {
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 16px;
  border-bottom: solid 2px #ddd;
  .question-btm {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .question-arrow {
    width: 13%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .question-info {
    width: 87%;
  }
}

.question-block-inline {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.question-title {
  font-size: 16px;
  line-height: 24px;
  color: #2a2b2b;
  margin-bottom: 6px;
}

.question-ordercode {
  font-size: 12px;
  color: #8e9091;
}

.question-content {
  font-size: 15px;
  line-height: 24px;
  color: #989898;
}

.question-time {
  font-size: 12px;
  color: #8e9091;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.question-time > img {
  width: 8px;
  height: 14px;
}

.theme--light.v-btn:hover:before {
  opacity: 0 !important;
}

h1 {
  font-size: 14px;
  font-weight: normal;
  color: #8e9091;
  padding: 16px 16px 9px 16px;
}

h2 {
  font-weight: 600;
  font-size: 18px;
  color: #2a2b2b;
  padding: 8px 16px;
}

.inline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  h2 {
    padding: 0;
  }
  .record-btn {
    color: #2a2b2b;
    font-size: 14px;
  }
}

.contact-area {
  padding: 20px 16px 42px 20px;
  background-color: #fff;
  color: #8e9091;
  font-size: 12px;
  line-height: 1.6;
  .contact-btn {
    color: #1ea7fc;
    font-size: 16px;
    display: flex;
    align-items: center;
    padding: 14px 0;
    img {
      margin-right: 10px;
    }
  }
}



</style>
